import React, { useState } from "react";

import { formatDateToYYYYMMDD } from "~/features/meetings/calendar-utils";
import { CalendarWidget } from "~/features/meetings/calendar-widget";
import { useGetMonthSlotsQuery } from "~/features/meetings/meetings-api";
import type { TExpert } from "~/features/meetings/meetings-types";

export function RescheduleWidget({ expert }: { expert: TExpert }) {
  const [date, setDate] = useState(new Date());
  const slotsQuery = useGetMonthSlotsQuery({
    expert_id: expert.account_id.toString(),
    date: formatDateToYYYYMMDD(date),
  });
  const slots = slotsQuery.data ?? [];

  return (
    // Fill the dialog while each calendar skin controls its internal alignment.
    <div className="tw-w-full">
      <CalendarWidget
        slots={slots}
        slotsAreLoading={slotsQuery.isFetching}
        onMonthChange={setDate}
      />
    </div>
  );
}
